import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const teacherGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isTeacher().pipe(
    map((isTeacher) => {
      if (!isTeacher) {
        router.navigate(['/student/dashboard']);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate(['/']);
      return of(false);
    }),
  );
};
